import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { User } from "tabler-icons-react";
import Button from "@/components/common/Buttons/Button";
import AddressInfo from "@/components/user-info/AddressInfo";
import ContactInfo from "@/components/user-info/ContactInfo";
import IDInfo from "@/components/user-info/IDInfo";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";
import { useStore } from "@/store";

export const Route = createFileRoute("/$locale/$partner/_app/_card/user-info")({
	component: UserInfoPage,
});

function UserInfoPage() {
	const { t } = useTranslation();
	const { goToNextStep } = useNavigationHelpers();
	const configUserInfo = useStore((state) => state.config?.pagesConfig?.userInfo);
	const hasContactInfo = configUserInfo?.contactInfo;
	const hasAddressInfo = configUserInfo?.addressInfo;
	const hasIDInfo = configUserInfo?.idInfo;

	const [validContact, setValidContact] = useState(!hasContactInfo);
	const [validAddress, setValidAddress] = useState(!hasAddressInfo);
	const [validID, setValidID] = useState(!hasIDInfo);

	function allValid() {
		return validContact && validAddress && validID;
	}

	function submit() {
		if (!allValid()) return;
		goToNextStep();
	}

	return (
		<div className="flex flex-col items-center justify-start h-full overflow-y-auto overflow-x-hidden grow pt-10 lg:pt-20">
			<div className="flex flex-col items-center space-y-2.5 mb-8">
				<User
					width={56}
					height={56}
				/>
				<h3>{t("User info.User info")}</h3>
			</div>
			<div className="px-5 w-full max-w-[600px]">
				{hasContactInfo && <ContactInfo onValidChange={setValidContact} />}
				{hasAddressInfo && <AddressInfo onValidChange={setValidAddress} />}
				{hasIDInfo && <IDInfo onValidChange={setValidID} />}
			</div>
			<div className="sticky bottom-0 bg-fixed-buttons w-full flex flex-col-reverse sm:flex-row flex-wrap items-center justify-center mt-auto pt-8 sm:gap-2 lg:gap-4">
				<Button
					intent="primary"
					label={t("btn.Continue")}
					disabled={!allValid()}
					onClick={submit}
				/>
			</div>
		</div>
	);
}
